/**
 * Official Grand Arena beer sponsor. Reuse this lockup on chyrons, arena boards,
 * later VO, and "presented by" lines — do not invent a second house beer.
 */
export const MAIN_SPONSOR_ID = 'oathstein';
export const MAIN_SPONSOR_BRAND = 'Oathstein';
export const MAIN_SPONSOR_PRODUCT = 'Oathstein Golden Lager';
export const MAIN_SPONSOR_TAGLINE = "This Oathstein's for you.";

export function presentedBySponsor(brand: string = MAIN_SPONSOR_BRAND): string {
  return `Presented by ${brand}`;
}
